import styled from 'styled-components/macro'

export const ContentsDown = styled.div<{ visible: boolean }>`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  padding: 20px 0;

  @media ${(props) => props.theme.media.xl} {
    height: 300px;
  }
`

export const SymbolWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  flex-direction: row;
  justify-content: flex-start;
`
